import { TaskStatusEnum_Enum_ } from 'models';
import { MinusIcon } from 'Tokens/Icons/Data';
import { CheckIcon, LoaderIcon } from 'Tokens/Icons/Status';

export const TASK_STATUS = {
  [TaskStatusEnum_Enum_.Completed_]: {
    title: 'Completed',
    icon: CheckIcon,
  },
  [TaskStatusEnum_Enum_.InProgress_]: {
    title: 'In progress',
    icon: LoaderIcon,
  },
  [TaskStatusEnum_Enum_.NotStarted_]: {
    title: 'Not started',
    icon: MinusIcon,
  },
};
